<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center forgot-outer-container"
  >
    <div class="col-12 col-md-7 col-lg-5 col-xl-4 p-0">
      <div class="d-flex justify-content-center">
        <div class="mt-3">
          <img
            src="/favicon/c3-logo.png"
            class="rounded"
            alt="Community Care Connection"
          />
        </div>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-4 my-5 p-0">
      <div class="card shadow-card p-5 login-box-container">
        <h1 class="display-4 text-center mb-3 mt-4">Reset Password</h1>
        <p class="text-muted text-center mb-5">Community Care Connection</p>
        <form
          name="ForgotPasswordForm"
          class="forgot-password-form"
          autocomplete="off"
          validate
          @submit.prevent="forgotPassword"
        >
          <div class="form-group">
            <input-control v-model="email" id="email" control="email" required
              >Email Address
            </input-control>
          </div>
          <save
            :saving="auth.sendingResetEmail"
            classes="btn btn-lg btn-block btn-primary mb-3"
          >
            Send Reset Link
          </save>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "forgotpassword",
  computed: {
    ...mapState(["auth"]),
  },
  data() {
    return {
      email: "",
    };
  },
  methods: {
    ...mapActions({
      sendForgotPassword: "auth/forgotPassword",
    }),
    forgotPassword() {
      this.sendForgotPassword({ email: this.email }).then(
        ({ success, err }) => {
          if (success) {
            Swal.fire({
              title: "Reset Link sent",
              text: "Please check your email for the password reset link.",
              type: "success",
            });
            this.$router.push({ name: "login" });
          } else {
            Swal.fire({
              title: "Error",
              text: ((err.data || {}).error || err.error || {}).message,
              type: "error",
            });
          }
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.forgot-password-form {
  margin-top: 20px;
}

@media (max-width: 1024px) {
  .forgot-outer-container {
    margin-top: -84px;
  }
}
</style>
